<powerbi-visual title="powerbi" #reportEmbed [cssClassName]="'report-container'"  [embedConfig]="embedConfig"
    [phasedEmbedding]="phasedEmbeddingFlag" [eventHandlers]="eventHandlersMap">
</powerbi-visual>